import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import urls from 'utils/config';
import {
  notifyApplicantsFailure,
  notifyApplicantsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* notifyApplicants({ payload: { payload, cb } }) {
  const url = `${API_BASE_URL}/candidates/notify`;

  const data = {
    applicationId: payload.id,
    stepId: payload.stepId
  }

  if (payload.applicants) {
    data.ids = payload.applicants
  }

  const response = yield request({
    method: 'post',
    url,
    data
  });
  if (response.success) {
    cb();
    // if (payload.stage === 'ACCEPTED') {
    //   yield put(fetchAdmittedCandidatesStart({ ...payload.filters }));
    // }
    // if (payload.stage === 'DECLINED') {
    //   yield put(fetchDeclinedCandidatesStart({ ...payload.filters }));
    // }

    yield put(notifyApplicantsSuccess());
    Notify('Applicants notified successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(notifyApplicantsFailure(response.message));
  }
}

export function* onNotifyApplicants() {
  yield takeEvery(
    ApplicantsActionTypes.NOTIFY_APPLICANT_START,
    notifyApplicants
  );
}
